import ButtonTransparent from "@erecht24/frontend-kit/theme/components/buttons/ButtonTransparent";
import Input from "@erecht24/frontend-kit/theme/components/inputs/Input";
import {useContext, useState} from "react";
import {StateContext} from "../Contexts";
import CouponCode from "./CouponCode";
import ValidationToolTip from "./ValidationToolTip";
import {addToCart} from "../Billwerk/SubscriptionJS";
import {track} from "../Util/tracking";
import {STEP_PLAN} from "../Constants";

export default function (props) {
    /** @type CheckoutState */
    const state = useContext(StateContext);
    const [coupon, setCoupon] = useState(state.coupon ?? '');

    const onEnter = (event, callback) => {
        if (event.key === 'Enter') {
            callback();
        }
    }

    const updateCoupon = () => {
        state.setCoupon(coupon);
        state.setCouponError(null);
        state.setCart(cart => addToCart(state, cart, {
            couponCode: coupon
        }));
        setCoupon('');
    };

    return <div {...props} className={`flex flex-col ${props.className ?? ''}`}>
        {(state.step === STEP_PLAN && (!state.cartViewData?.couponCode || !state.cartViewData?.couponAppliesToCart)) &&
            <div className="flex flex-row justify-between relative gap-4 my-4">
                <div className="relative w-full">
                    <Input label="Gutscheincode"
                           variant="outlined"
                           size="md_uc"
                           defaultValue={coupon}
                           value={coupon}
                           onChange={(event) => {
                               setCoupon(event.target.value)

                               if (!event.target.value) {
                                   updateCoupon();
                               }
                           }}
                           onKeyDown={(event) => onEnter(event, () => track(updateCoupon, 'checkout', 'voucher_submitted', 'redeemed_voucher', 'true'))}
                           error={state.couponError !== null}
                    ></Input>
                    {(state.couponError !== null) && (
                        <ValidationToolTip>{state.couponError}</ValidationToolTip>
                    )}
                </div>
                <ButtonTransparent onClick={() => track(updateCoupon, 'checkout', 'voucher_submitted', 'redeemed_voucher', 'true')} disabled={state.coupon && state.cartViewData?.couponAppliesToCart}>einlösen</ButtonTransparent>
            </div>
        }
        {(state.cartViewData?.couponCode && state.cartViewData?.couponAppliesToCart) && (
            <div className="flex flex-row justify-between items-center">
                <span className="text-xl text-graphite font-bold">Gutscheincode</span>
                <CouponCode>{state.cartViewData?.couponCode}</CouponCode>
            </div>
        )}
    </div>
}
